























import Vue from 'vue'
import FileUpload from '@/UI/Shared/FileUpload/FileUpload.vue'
import { FileUploadOptions } from '@/UI/Shared/FileUpload/FileUploadOptions'
import { VerificationData } from '@/Infrastructure/Store/Auction/VerificationData'
interface VerificationItemData {
  previusDoc: VerificationData | null;
}

export default Vue.extend({
  name: 'VerificationsItem',
  components: {
    FileUpload
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    previusVerificationData: {
      type: Array as () => VerificationData[]
    },
    procedureId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data (): VerificationItemData {
    return {
      previusDoc: null
    }
  },
  computed: {
    options (): FileUploadOptions {
      return {
        url: this.getBaseUrl,
        acceptedFiles: 'application/pdf,.zip',
        maxFilesize: 30,
        maxFiles: 1,
        chunkSize: 500,
        createImageThumbnails: false,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        addRemoveLinks: true,
        dictDefaultMessage: this.$t('shared.fileUpload.dictDefaultMessage').toString(),
        dictFallbackMessage: this.$t('shared.fileUpload.dictFallbackMessage').toString(),
        dictFallbackText: this.$t('shared.fileUpload.dictFallbackText').toString(),
        dictFileTooBig: this.$t('shared.fileUpload.dictFileTooBig').toString(),
        dictBadExtension: this.$t('shared.fileUpload.dictBadExtension').toString(),
        dictResponseError: this.$t('shared.fileUpload.dictResponseError').toString(),
        dictCancelUpload: this.$t('shared.fileUpload.dictCancelUpload').toString(),
        dictUploadCanceled: this.$t('shared.fileUpload.dictUploadCanceled').toString(),
        dictCancelUploadConfirmation: this.$t('shared.fileUpload.dictCancelUploadConfirmation').toString(),
        dictRemoveFile: this.$t('shared.fileUpload.dictRemoveFile').toString(),
        dictMaxFilesExceeded: this.$t('shared.fileUpload.dictMaxFilesExceeded').toString()
      }
    },
    getBaseUrl (): string {
      if (process.env.VUE_APP_API_ENV === 'local') {
        return 'https://httpbin.org/post'
      }
      return process.env.VUE_APP_API_URL + `/sobree/api/documentation/verifications/${this.procedureId}/${this.userId}`
    }
  },
  watch: {
    previusDoc (newValue: VerificationData) {
      if (newValue !== undefined && !newValue.opposeToQuery) {
        this.$emit('verification-failed', this.id)
      }
    }
  },
  created () {
    this.previusDoc = this.returnEmpty(this.id)
  },
  mounted () {
    this.setVerification(this.previusVerificationData)
  },
  methods: {
    onMainCheckBoxClicked (check: boolean) {
      if (this.previusDoc !== null) {
        if (check === false) { this.previusDoc.fileName = '' }
        this.previusDoc.opposeToQuery = check
        this.$emit('verification-updated', this.previusDoc)
      }
    },
    onFileAddComplete (name: string) {
      if (this.previusDoc === null) {
        return
      }
      this.previusDoc.fileName = name

      if (name === '') {
        this.$emit('verification-failed', this.id)
      } else {
        this.previusDoc.id = this.id
        this.previusDoc.opposeToQuery = true

        this.$emit('verification-updated', this.previusDoc)
      }
    },
    setVerification (doc: VerificationData []): void {
      if (doc.length > 0) {
        const selectedPreviousData = doc.find((current: VerificationData) => {
          return current.id === this.id
        })

        if (selectedPreviousData != null) {
          const data: VerificationData = {
            id: selectedPreviousData.id,
            fileName: selectedPreviousData.fileName,
            opposeToQuery: selectedPreviousData.opposeToQuery
          }

          this.previusDoc = data
        } else { this.previusDoc = this.returnEmpty(this.id) }
      } else { this.previusDoc = this.returnEmpty(this.id) }
    },
    returnEmpty (idFile: number): VerificationData {
      const data: VerificationData = {
        id: idFile,
        fileName: '',
        opposeToQuery: false
      }
      return data
    }
  }
})
